import React from "react";
import resetPassword from "assets/Login/thank-you.png";
import thankyouImg from "assets/Login/thankyou.png";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import Button from "components/molecules/Button";
import {useNavigate} from "react-router-dom";
import {clearCookie} from "helpers/common";
import {useAuthContext} from "Context/authContext";
const Thankyou = () => {
    const navigate = useNavigate();
    const {setIsLoggedIn} = useAuthContext();
    const handleOnClick = () => {
        setIsLoggedIn(false);
        clearCookie(process.env.REACT_APP_FOODIE_TOKEN_COOKIE);
        clearCookie(process.env.REACT_APP_ALLOWED_PAGES_COOKIE);
        clearCookie("is_email_verified");
        sessionStorage.removeItem("userEmail");
        navigate("/login");
    };
    return (
        <OnBoardingLayout img={resetPassword} heading={true}>
            <div className="thankyouWrap">
                <div className="imgHolder">
                    <img src={thankyouImg} alt="thank you" />
                </div>
                <p>
                    for creating your business! We will review it and get back to you shortly. You will be able to
                    access the FLOWDISH Business Accelerator Portal once a verification is approved.
                </p>
                <Button onClick={handleOnClick}>Continue</Button>
            </div>
        </OnBoardingLayout>
    );
};

export default Thankyou;
